import React, { useEffect, useState } from "react";
import Hero from "../components/Hero/Hero";
import SpecialistFinder from "../components/SpecialistFinder/SpecialistFinder";
import HealthcarePartner from "../components/HealthcarePartner/HealthcarePartner";
import DataPrivacy from "../components/DataPrivacy/DataPrivacy";
import AppPromo from "../components/AppPromo/AppPromo";
import HealthcareCTA from "../components/HealthcareCTA/HealthcareCTA";
import HelpSection from "../components/HelpSection/HelpSection";
import Services from "../components/Services/Services";
import Biocapteurs from "../components/Biocapteurs/Biocapteurs";
import Appointment from "../components/Appointment/Appointment";
import Teleconsultation from "../components/Teleconsultation/Teleconsultation";
import AboutUs from "../components/AboutUs/AboutUs";
import SoinsDomicile from "../components/SoinsDomicile/SoinsDomicile";
import Certification from "../components/Certification/Certification";
import NosTrophees from "../components/NosTrophees/NosTrophees";
import ProfessionalHealthPage from "./ProfessionalHealthPage";
import QrCode from "../QrCode";

import { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Inscription from "../components/inscription/Inscription";

const Home: React.FC = () => {
  const [showScroll, setShowScroll] = useState(false);

  const goUp = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScroll(true);
      } else {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="home">
      <Hero />
      <Certification />
      <AppPromo />
      <NosTrophees />
      <AboutUs />
      <HealthcarePartner />
      <DataPrivacy />
      <Services />
      <Appointment />
      <Teleconsultation />
      <Biocapteurs />
      <HelpSection />
      <a href="#" style={{ opacity: showScroll ? 1 : 0, transition: "1s" }}>
        <button className="scroll2Top">
          {" "}
          <FontAwesomeIcon icon={faArrowUp}  style={{color:"white"}} />
        </button>
      </a>
    </div>
  );
};

export default Home;
